var _this = this;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { inject, observer } from 'mobx-react';

import moment from 'moment';

import { Editor } from '../Editor';

export var DateFormatter = function DateFormatter(_ref) {
  var date = _ref.date,
      fmt = _ref.fmt,
      _ref$as = _ref.as,
      T = _ref$as === undefined ? 'div' : _ref$as;
  return date ? React.createElement(
    T,
    null,
    moment(date).format(fmt || 'DD.MM.YY')
  ) : null;
};

var parse = function parse(value, month) {
  if (value.indexOf('.') < 0) {
    value = ('0' + value).slice(-2);
    return moment.utc(month + value, 'YYYYMMDD');
  } else return moment.utc(value, 'DD.MM.YYYY');
};

export var DateCellEditor = function DateCellEditor(_ref2) {
  var cell = _ref2.cell,
      update = _ref2.update,
      _ref2$fmt = _ref2.fmt,
      fmt = _ref2$fmt === undefined ? 'DD.MM.YY' : _ref2$fmt;
  return React.createElement(
    Editor,
    { contentEditable: true, suppressContentEditableWarning: true,
      onFocus: function onFocus(e) {
        window.getSelection().selectAllChildren(e.target);
      },
      onBlur: function onBlur(e) {
        var _extends2;

        var field = cell.column.id;
        var value = e.target.textContent;
        var month = cell.original.month;

        var date = parse(value, month);

        update(_extends({}, cell.original, (_extends2 = {}, _extends2[field] = date.valueOf(), _extends2)));
      }
    },
    cell.value && moment(cell.value).format(fmt)
  );
};

export var DateFieldEditor = inject('store', 'monthStore')(observer(function (_ref3) {
  var store = _ref3.store,
      monthStore = _ref3.monthStore,
      field = _ref3.field,
      _ref3$fmt = _ref3.fmt,
      fmt = _ref3$fmt === undefined ? 'DD.MM.YY' : _ref3$fmt;
  return React.createElement(
    Editor,
    { contentEditable: true, suppressContentEditableWarning: true,
      onFocus: function onFocus(e) {
        window.getSelection().selectAllChildren(e.target);
      },
      onBlur: function onBlur(e) {
        var value = e.target.textContent;
        var month = monthStore.month.num;

        var date = parse(value, month);

        store.updateField(field, date.valueOf());
      }
    },
    store.editable[_this.props.field] && moment(store.editable[field]).format(fmt)
  );
}));